import { STATIC_STRINGS } from "@asez/shared";

function Grids({ outputGrid }) {
  return (
    <div className="mt-4">
      <h2 className="text-lg font-semibold mb-2">
        {STATIC_STRINGS.QUESTION_WISE_REPORT_ENUM.OUTPUT_GRIDS}
      </h2>
      <div className="inline-block border border-gray-400 rounded overflow-hidden">
        {outputGrid.map((row, rowIndex) => (
          <div key={rowIndex} className="flex">
            {row.map((cell, colIndex) => (
              <div
                key={colIndex}
                className={`w-8 h-8 flex items-center justify-center border border-gray-300 text-sm font-semibold
                            ${
                              cell === 0
                                ? "bg-gray-200"
                                : cell === 8
                                ? "bg-blue-500 text-white"
                                : cell === 1
                                ? "bg-green-500 text-white"
                                : cell === 4
                                ? "bg-yellow-500 text-white"
                                : cell === 2
                                ? "bg-red-500 text-white"
                                : "bg-white"
                            }`}
              >
                {cell}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Grids;
